import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/css/icons.css';
import '../../assets/css/style.css'
import { SERVER_IP, PORT, ud, jwt, auth_response_flow } from '../../Server'
import axios from 'axios';

import DropdownTreeSelect from 'react-dropdown-tree-select'
import 'react-dropdown-tree-select/dist/styles.css'
import swal from 'sweetalert';
import $ from 'jquery';
import MultiDropDown from '../Components/MultiDropdown';



class CreateUser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: "",
            cname: '',
            phone: '',
            logo: '',
            city: '',
            zip: '',
            address: '',
            details: '',
            stateAddress: '',
            typeHierarchy: [],
            departmentSelected: [],
            equipmentSelected: [],
            unitSelected: [],
            dynamicSelectedType: [],
            image: '',
            designation: '',
            uniqueID: '',
            usrtTypeRadios: 'SME',
            Rating: 0,
            errors: {
                cname: '',
                email: '',
                cpassword: '',

                // password: '',

            }
        }
    }

    checkRequirement = (name, value) => {

        let errors = this.state.errors;

        switch (name) {
            case 'cname':
                errors.cname =
                    value.length < 1
                        ? 'Please Fill The Detail.'
                        : '';
                break;
            case 'email':
                errors.email =
                    validEmailRegex.test(value)
                        ? ''
                        : 'Email is not valid!';
                break;

            // case 'password':
            //     errors.password =
            //         value.length < 8
            //             ? 'Password must be 8 characters long!'
            //             : '';
            //     break;
            // case 'cpassword':
            //     errors.password =
            //         this.state.password !== value
            //             ? 'Password and Confirm Password does not match!'
            //             : '';
            //     break;
            default:
                break;
        }

        this.setState({ errors });
    }

    onChangeInput = (e) => {
        e.preventDefault();

        this.checkRequirement(e.target.name, e.target.value);
        this.setState({ [e.target.name]: e.target.value })
    }
    onChangeInputRadio = (e) => {


        this.setState({ [e.target.name]: e.target.value })
    }
    handleImageChange = (e) => {
        e.preventDefault();
        if (!e.target.files[0]) {
            return
        }
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = () => {
            this.setState({
                image: reader.result
            });

        };
    }

    submit = (e) => {
        e.preventDefault();
        Object.keys(this.state.errors).map((list, index) => this.checkRequirement(list, this.state[list]))
        this.checkRequirement(e)
        if (validateForm(this.state.errors)) {


        } else {
            swal("Invalid Input ..!!")
            return
        }

        // if (this.state.password != this.state.cpassword) {
        //     swal("Invalid Password ..!!")
        //     return
        // }
        var getselected = [];
        this.state.dynamicSelectedType.map((list, index) => list.length != 0 ? getselected.push(list.map((li, ind) => li.id)) : undefined)

        var filteredSelectedTypes = [].concat.apply([], getselected);

        if (filteredSelectedTypes.length == 0) {
            swal("Please fill the all details.", "", "warning")
            return
        }
        var data = {
            name: this.state.cname,
            email: this.state.email,
            phone: this.state.phone,
            type_id: filteredSelectedTypes,
            usertype: this.state.usrtTypeRadios === "SME" ? 1 : 2,
            final_rating: this.state.Rating,
            address: this.state.address,
            password: JSON.stringify(Math.floor(1000 + Math.random() * 9000)),
            ud: ud.main_id,

            jwt: jwt,
            profile_pic: this.state.image,
            city: this.state.city,
            state: this.state.stateAddress,
            zip: this.state.zip,
            designation: this.state.designation,
            uniqueID: this.state.uniqueID
        }

        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        let _this = this;
        axios.post(`${SERVER_IP}/create/user`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data.error === false) {
                        swal(response.data.message)
                        window.location.href = "/create/listuser"
                    } else {
                        auth_response_flow(response.data, (return_response) => {
                            if (return_response.error === false && return_response.retry === true) {
                                _this.submit(e);
                            }
                        })
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
                swal("Something Went Wrong. Please Retry.")
            });
    }
    convert = (array) => {
        var map = {};
        for (var i = 0; i < array.length; i++) {
            var obj = array[i];
            obj.children = [];

            map[obj.id] = obj;

            var parent_id = obj.parent_id || '-';
            if (!map[parent_id]) {
                map[parent_id] = {
                    children: []
                };
            }
            map[parent_id].children.push(obj);
        }

        return map['-'].children;

    }
    componentDidMount() {
        this.getTotalType()
    }

    getTotalType = () => {
        var data = {
            jwt: jwt,
            s_id: ud.main_id
        }
        let _this = this;
        var heirarchy = this.state.heirarchy
        let headers = {
            'user_id': (ud.id).toString(),
            'session_id': (ud.session_id).toString(),
            'user_type': (ud.usertype).toString(),
            'main_id': (ud.main_id).toString(),
            'jwt_token': (jwt),
            'c_id': (ud.c_id).toString()
        }
        axios.post(`${SERVER_IP}/view/typesfordropdown`, data, { withCredentials: true, headers: headers })
            .then(function (response) {
                if (response.data.error === false) {
                    var r = _this.convert(response.data.result.result)
                    var temparr = [];
                    r.map((list, index) => { temparr.push([]) })
                    _this.setState({ typeHierarchy: r, dynamicSelectedType: temparr });

                } else {
                    auth_response_flow(response.data, (return_response) => {
                        if (return_response.error === false && return_response.retry === true) {
                            _this.getTotalType();
                        }
                    })
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    onChangeDropdownDepartment = (currentNode, selectedNodes) => {

        this.setState({ departmentSelected: selectedNodes })
    }
    onChangeDropdownEquipment = (currentNode, selectedNodes) => {
        this.setState({ equipmentSelected: selectedNodes })

    }
    onChangeDropdownUnit = (currentNode, selectedNodes) => {
        this.setState({ unitSelected: selectedNodes })
    }
    onAction = (node, action) => {
        // console.log('onAction::', action, node)
    }
    onNodeToggle = currentNode => {
        // console.log('onNodeToggle::', currentNode)
    }
    onChangeDropdown = (index, currentNode, selectedNodes) => {
        this.state.dynamicSelectedType[index] = selectedNodes;
        this.setState(this.state)
    }

    render() {
        const { errors } = this.state;
        if (this.state.typeHierarchy.length === 0) {
            return (
                <div>
                    <div class="xp-breadcrumbbar">
                        <div class="row">
                            <div class="col-md-6 col-lg-6">
                            </div>
                            <div class="col-md-6 col-lg-6">
                                <div class="xp-breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                        <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listuser"}>List Users</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="xp-contentbar">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card m-b-30">
                                    <div className="card-header bg-primary">
                                        <h5 className="card-title text-white">Create User</h5>
                                        {/* <h6 className="card-subtitle">Here’s a quick example to demonstrate Bootstrap’s form styles. Keep reading for documentation on required classes, form layout, and more.</h6> */}
                                    </div>
                                    <div className="card-body">
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">There Is No Organizational Structure Created.</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div>
                    <div class="xp-breadcrumbbar">
                        <div class="row">
                            <div class="col-md-6 col-lg-6">
                                <h3 className="xp-page-title">Create User</h3>
                            </div>
                            <div class="col-md-12 col-lg-12">
                                <div class="xp-breadcrumb">
                                    <ol class="breadcrumb">
                                        <li class="breadcrumb-item"><a onClick={() => window.location.href = "/dashboard"}><i class="icon-home"></i></a></li>
                                        <li class="breadcrumb-item active" onClick={() => window.location.href = "/create/listuser"}>List Users</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="xp-contentbar p-30">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card m-b-30">
                                    <div className="card-header bg-primary">
                                        <h5 className="card-title text-white">Create User</h5>
                                        {/* <h6 className="card-subtitle">Here’s a quick example to demonstrate Bootstrap’s form styles. Keep reading for documentation on required classes, form layout, and more.</h6> */}
                                    </div>
                                    <div className="card-body">
                                        <div className="form-row">
                                            <div className="form-group col-md-12">
                                                <label for="exampleInputEmail1">Name
                                               <i class="text-danger">*</i>
                                                </label>

                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-account"></i></span>
                                                    </div>
                                                    <input type="text" onChange={this.onChangeInput} name="cname" className="form-control" placeholder="Enter User Name" />
                                                    {errors.cname.length > 0 && <span className='text-danger'>{errors.cname}</span>}
                                                </div>
                                            </div>
                                            {/* <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Profile Image</label>
                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-file-image"></i></span>
                                                    </div>
                                                    <input type="file" onChange={this.handleImageChange} name="logo" className="form-control" placeholder="Upload Image" accept="image/*" />
                                                </div>

                                            </div> */}
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Employee Id </label>

                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-account"></i></span>
                                                    </div>
                                                    <input type="text" onChange={this.onChangeInput} name="uniqueID" className="form-control" placeholder="Enter Employee ID" />
                                                    {/* {errors.cname.length > 0 && <span className='text-danger'>{errors.uniqueID}</span>} */}
                                                </div>
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Designation </label>

                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-account"></i></span>
                                                    </div>
                                                    <input type="text" onChange={this.onChangeInput} name="designation" className="form-control" placeholder="Enter Designation" />
                                                    {/* {errors.cname.length > 0 && <span className='text-danger'>{errors.designation}</span>} */}
                                                </div>
                                            </div>
                                        </div>


                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Email <i class="text-danger">*</i></label>
                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-email"></i></span>
                                                    </div>
                                                    <input type="text" onChange={this.onChangeInput} name="email" className="form-control" placeholder="example@domain.com" />
                                                    {errors.email.length > 0 && <span className='text-danger'>{errors.email}</span>}
                                                </div>
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Phone </label>
                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-phone"></i></span>
                                                    </div>
                                                    <input type="number" onChange={this.onChangeInput} name="phone" className="form-control" placeholder="Enter Phone Number" />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="form-group">
                                            <label for="exampleInputEmail1">Address </label>
                                            <div className="input-group">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i className="mdi mdi-account-card-details"></i></span>
                                                </div>
                                                <input type="text" onChange={this.onChangeInput} name="address" className="form-control" placeholder="Enter Address" />
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">City </label>
                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-earth"></i></span>
                                                    </div>
                                                    <input type="text" onChange={this.onChangeInput} name="city" className="form-control" placeholder="Enter City Name" />
                                                </div>
                                            </div>
                                            <div className="form-group col-md-4">
                                                <label for="exampleInputEmail1">State </label>
                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-earth"></i></span>
                                                    </div>
                                                    <input type="text" onChange={this.onChangeInput} name="stateAddress" className="form-control" placeholder="Enter State Name" />
                                                </div>
                                            </div>
                                            <div className="form-group col-md-2">
                                                <label for="exampleInputEmail1">ZIP </label>
                                                <div className="input-group">
                                                    <div class="input-group-prepend">
                                                        <span class="input-group-text"><i className="mdi mdi-numeric"></i></span>
                                                    </div>
                                                    <input type="number" onChange={this.onChangeInput} name="zip" className="form-control" placeholder="Enter ZIP" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-row">
                                            {this.state.typeHierarchy.map((list, index) => <div>
                                                {list.children.length > 0 ?
                                                    <div className="form-group float-left mr-4">
                                                        <label for="exampleInputEmail1">{list.label}</label>
                                                        <MultiDropDown index={index} data={list} onChange={this.onChangeDropdown} onAction={this.onAction} onNodeToggle={this.onNodeToggle} />
                                                    </div>
                                                    : null}
                                            </div>)}
                                        </div>


                                        <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">User Type <i class="text-danger">*</i></label>

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" onChange={this.onChangeInputRadio} className="custom-control-input" checked={this.state.usrtTypeRadios == "SME"} id="defaultUnchecked" value="SME" name="usrtTypeRadios" />
                                                    <label class="custom-control-label" for="defaultUnchecked"> SME</label>
                                                </div>

                                                <div class="custom-control custom-radio">
                                                    <input type="radio" onChange={this.onChangeInputRadio} className="custom-control-input" value="FO" checked={this.state.usrtTypeRadios == "FO"} id="defaultChecked1" name="usrtTypeRadios" />
                                                    <label class="custom-control-label" for="defaultChecked1">FO</label>
                                                </div>
                                            </div>


                                            <div className="form-group col-md-6">
                                                <div class="form-group" id="rating-ability-wrapper">
                                                    <label class="control-label" for="rating">
                                                        <span class="field-label-header"> Rating 
                                                            <span> 
                                                                <span class="selected-rating"> ({this.state.Rating}
                                                                </span>
                                                                <small> / 5</small>)
                                                            </span> 
                                                         </span><br />
                                                        <span class="field-label-info"></span>
                                                        <input type="hidden" id="selected_rating" name="selected_rating" value="" />
                                                    </label>
                                                    <h2 class="bold rating-header" >
                                                       
                                                    </h2>
                                                    <ul className="star-rating">
                                                        <li><button type="button" class={`${this.state.Rating >= 1 ? "btnrating btn btn-lg btn-warning" : "btnrating btn btn-default btn-lg"}`} onClick={() => this.setState({ Rating: 1 })}>
                                                            <i class="fa fa-star" aria-hidden="true"></i>
                                                        </button></li>

                                                        <li><button type="button" class={`${this.state.Rating >= 2 ? "btnrating btn btn-lg btn-warning" : "btnrating btn btn-default btn-lg"}`} data-attr="2" onClick={() => this.setState({ Rating: 2 })}>
                                                            <i class="fa fa-star" aria-hidden="true"></i>
                                                        </button></li>

                                                        <li><button type="button" class={`${this.state.Rating >= 3 ? "btnrating btn btn-lg btn-warning" : "btnrating btn btn-default btn-lg"}`} onClick={() => this.setState({ Rating: 3 })}>
                                                            <i class="fa fa-star" aria-hidden="true"></i>
                                                        </button></li>

                                                        <li><button type="button" class={`${this.state.Rating >= 4 ? "btnrating btn btn-lg btn-warning" : "btnrating btn btn-default btn-lg"}`} onClick={() => this.setState({ Rating: 4 })}>
                                                            <i class="fa fa-star" aria-hidden="true"></i>
                                                        </button></li>

                                                        <li> <button type="button" class={`${this.state.Rating >= 5 ? "btnrating btn btn-lg btn-warning" : "btnrating btn btn-default btn-lg"}`} onClick={() => this.setState({ Rating: 5 })}>
                                                            <i class="fa fa-star" aria-hidden="true"></i>
                                                        </button></li>
                                                    </ul>


                                                </div>
                                            </div>
                                        </div>


                                        {/* <div className="form-row">
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Password</label>
                                                <input type="password" onChange={this.onChangeInput} name="password" className="form-control" placeholder="Enter Password" />
                                                {errors.password.length > 0 && <span className='text-danger'>{errors.password}</span>}
                                            </div>
                                            <div className="form-group col-md-6">
                                                <label for="exampleInputEmail1">Confirm Password</label>
                                                <input type="password" onChange={this.onChangeInput} name="cpassword" className="form-control" placeholder="Re Enter Password" />
                                                {errors.cpassword.length > 0 && <span className='text-danger'>{errors.cpassword}</span>}
                                            </div>
                                        </div> */}
                                        <button type="submit" onClick={this.submit} className="btn btn-primary">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        }

    }
}
export default CreateUser

const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
const validateForm = (errors) => {
    let valid = true;
    Object.values(errors).forEach(
        (val) => val.length > 0 && (valid = false)
    );
    return valid;
}